import clsx from 'clsx';
import { ReactNode } from 'react';
import { Alert } from '../../../components/Alert';
import { AlertProps } from '../../../components/Alert/Alert';
import styles from './HistoryAlertEdit.module.css';
import { LFC } from '../../../types';

interface HistoryAlertEditProps extends AlertProps {
  title: ReactNode;
  description: ReactNode;
}

export const HistoryAlertEdit: LFC<HistoryAlertEditProps> = ({
  children,
  title,
  description,
  className,
  ...rest
}) => {
  return (
    <Alert className={clsx(styles.alert, className)} {...rest}>
      <div>
        {title}
        <div className={styles.description}>{description}</div>
      </div>
      {children}
    </Alert>
  );
};
